import React from "react";
import {FieldProps} from "../List";
import Translation from "../../Utils/Translation";

export default ({value, ...props}: FieldProps) => {
    return <Translation id={value ? "yes" : "no"} base={[props.config.componentName + ".field." + props.field, props.config.componentName]} />
}